import React from 'react';
import { Button, ButtonProps } from '@mui/material';
import AppFeatures from '../AppFeatures';

interface FeatureButtonProps extends ButtonProps{
  features: AppFeatures[],
  featureValidator: (features:AppFeatures[]) => boolean;
}

const FeatureButton: React.FC<FeatureButtonProps> = ({children, features, featureValidator, ...otherProps}) => {
  return (
    <Button {...otherProps} disabled={!featureValidator(features)}>{children}</Button>
  );
};

export default FeatureButton;
